module.exports = __webpack_public_path__ + "img/excel.e253ff8c.png";